import React, { useState, useEffect, useContext, useRef } from "react";
import { Modal, Spinner } from "react-bootstrap";
import money from "../assets/images/icons/Money.svg";
import "../assets/css/Style.css";
import "react-datepicker/dist/react-datepicker.css";
import '../assets/css/CustomUtility.css'; // This is having invalid feedback and Datepicker related css
import "../styles/SchedulePayment.css";
import CustomDatePicker from "./DatePickerr.jsx";
import Forms from "../components/forms.jsx";
import { GetPayLoad } from "../services/PayLoadStorage"; /* st48236 - changes for schedule payment */
import { useNavigate } from "react-router-dom";
import { getApiService } from "../services/ApiService";
import parse from 'html-react-parser'; /* st48236 - changes for schedule payment */
import { postApiService } from "../services/ApiService"; /* st48236 - changes for schedule payment */
import { toast } from 'react-toastify';/* st48236 - changes for schedule payment */
import { LanguageContext } from "../contexts/LanguageContext";/* st48236 - changes for schedule payment */
import { postData } from "../services/EncryptService";
import Cookies from 'js-cookie';

const Schedulepayment = ({ handleCloseSchedulePaymentModal, contentFromExternal = null }) => {

	const schedulePaymentContentRef = useRef(null);
	const userInteractedRef = useRef(false);

	const handleDateSelect = (e) => {
		document.getElementById('datepicker-input').value = e;
		getUpdateNachaContent();
	};
	const handleRadioKeyDown = (e, id) => {
		const radios = [
			"amount_option_1",
			"amount_option_2",
			"amount_option_3",
		];

		const currentIndex = radios.indexOf(id);

		switch (e.key) {
			case "Enter":
			case " ":
				document.getElementById(id)?.click();
				break;

			case "ArrowDown":
			case "ArrowRight":
				e.preventDefault();
				const nextIndex = (currentIndex + 1) % radios.length;
				document.getElementById(radios[nextIndex])?.focus();
				break;

			case "ArrowUp":
			case "ArrowLeft":
				e.preventDefault();
				const prevIndex =
					(currentIndex - 1 + radios.length) % radios.length;
				document.getElementById(radios[prevIndex])?.focus();
				break;

			default:
				break;
		}
	};

	/* st48236 - changes for schedule payment */
	const Payload = GetPayLoad('PayLoad');
	const baseUrl = process.env.REACT_APP_API_BASE_URL;
	const headers = {
		"X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
		"X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
		"X-Hps-Region": Payload?.region,
		"X-Hps-Carrier": Payload?.owning_carrier
	};
	/* st48236 - changes for schedule payment */

	const [isChecked, setIsChecked] = useState(false);
	const [scheduledPayments, setScheduledPayments] = useState([]);
	/* st48236 - changes for schedule payment */
	const [activeAccounts, setActiveAccounts] = useState([]);
	const [nachaContents, setnachaContents] = useState('');
	const [duePayments, setDuePayments] = useState([]);
	const [carrierDraftDate, setCarrierDraftDate] = useState([]);
	const [primaryAccount, setPrimaryAccount] = useState([]);
	const [isPaymentLoading, setPaymentLoading] = useState(false);
	const [isFirstPaymentCheck, setIsFirstPaymentCheck] = useState(false);
	const [isSecondPaymentCheck, setIsSecondPaymentCheck] = useState(true);
	const [isThirdPaymentCheck, setIsThirdPaymentCheck] = useState(false);
	const [isNachaLoading, setNachLoading] = useState(true);
	const [isValidation, setValidation] = useState(true);
	const { pageContent } = useContext(LanguageContext);
	const [billingContent, setBillingContent] = useState([]);
	const [formErrors, setFormErrors] = useState([]);
	const [popupFormErrors, setPopupFormErrors] = useState([]);
	const [caseType, setcaseTypeArr] = useState('');
	const [caseTypeUSA, setcaseTypeUSAArr] = useState('');
	const [maxValidationAmt, setMaxValidationAmt] = useState('');
	const [autoPayFlag, setHideAutoPay] = useState(true);
	const [enableDraftOption, setEnableDraftOption] = useState(false);
	const [amtReadOnly, setAmtReadOnly] = useState([true]);
	const [schedulePayPopupModal, setSchedulePymntModelModal] = useState(false);
	const [recurringSchedulePaymentModal, setRecurringSchedulePaymentModal] = useState(false);
	const [continueSchedulePaymentModal, setContinueSchedulePaymentModal] = useState(false);
	const [cancelPayPopupModal, setCancelPymntModelModal] = useState(false);
	const [popupAmount, setPopupAmount] = useState('');
	const [popupDate, setPopupDate] = useState('');
	const [popupDay, setPopupDay] = useState('');
	const [carrierDateVerbage, setCarrierDateVerbage] = useState('');
	const [carrierName, setCarrierName] = useState('');
	const [continuePopupTitle, setContinuePopupTitle] = useState('');
	const [authFrequency, setAuthFrequency] = useState('.otp');
	const [cancelConfNum, setCancelConfNum] = useState('');
	const [cancelDataSource, setCancelDataSource] = useState('');
	const [isCancelPayLoading, setCancelPayLoading] = useState(false);
	const [isCancelSubmitting, setIsCancelSubmitting] = useState(false);
	const [caseInfo, setCaseInfo] = useState([]);
	const [addNew, setAddNew] = useState(false);
	const [confirmationNum, setConfirmationNum] = useState('');
	const [authorizationId, setAuthorizationId] = useState('');
	/* st48236 - changes for schedule payment */
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [isTermsAccepted, setIsTermsAccepted] = useState(false);
	const [recentScheduledPaymentsLoading, setRecentScheduledPaymentsLoading] = useState(true);
	const [genericContent, setGenericContent] = useState([]);
	
	const handleRecurringChange = (event) => {
		setIsChecked(!isChecked);
		let frequency = ".otp";
		if (document.querySelector('input[type="checkbox"][id="enable_recurring_draft"]')) {
			let auth_payment_option = document.querySelector('#enable_recurring_draft').checked;
			if (auth_payment_option) {
				frequency = '.recurring-otp';
			}
		}
		setAuthFrequency(frequency);
		getUpdateNachaContent(event);/* st48236 - changes for schedule payment */
	};


	const handleTermsChange = (event) => {
		if (document.querySelector('#auth_esignature_chkbox').checked) {
			setIsTermsAccepted(true);
		} else {
			setIsTermsAccepted(false);
		}
		setFormErrors(prevErrors => ({ ...prevErrors, esignature: '' }));
		getUpdateNachaContent(event);/* st48236 - changes for schedule payment */
	};

	function handleDataFromModal(message, statusCode) {
		if (message !== '' && statusCode === 'success') {
			toast.success(message);
			refreshAccounts();
		} else {
			toast.error(message);
		}
	}

	const replaceWord = (text, findWord, replaceWord) => {
		return text?.replace(findWord, replaceWord);
	};

	const handleAddNew = (e) => {
		e.preventDefault()
		setAddNew(true)
	}

	const handleCloseModal = () => {
		setAddNew(false);
	};

	const handleAlert = () => {
		setShowAlert(true);
		setTimeout(() => {
			setShowAlert(false);
		}, 5000);
	};
	const navigate = useNavigate();
	/* st48236 - changes for schedule payment */
	const [region, setRegion] = useState();
	const formatDate = (date) => {
		if (!date) return "";
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
		const day = String(date.getDate()).padStart(2, "0");
		return month + '/' + day + '/' + year;
	};

	let carrier_name = carrierName;
	const getAccountComobox = (event) => {
		setFormErrors(prevErrors => ({ ...prevErrors, account: '' }));
		setIsTermsAccepted(false);
		getUpdateNachaContent(event);
	};

	const getUpdateThirdAmt = (event) => {
		setFormErrors(prevErrors => ({ ...prevErrors, amount: '' }));
		setAmtReadOnly(false);
		getUpdateNachaContent(event);
	};

	const checkRadioBtn = (event) => {
		setFormErrors(prevErrors => ({ ...prevErrors, amount: '' }));
		let payment_amount = document.querySelector('input[name="payment_amount"]:checked');
		setIsFirstPaymentCheck(false);
		setIsSecondPaymentCheck(false);
		setIsThirdPaymentCheck(false);
		if (payment_amount.id === 'amount_option_1') {
			setIsFirstPaymentCheck(true);
		} else if (payment_amount.id === 'amount_option_2') {
			setIsSecondPaymentCheck(true);
		} else if (payment_amount.id === 'amount_option_3') {
			setIsThirdPaymentCheck(true);
		} else {
			setIsThirdPaymentCheck(false);
			setIsFirstPaymentCheck(false);
			setIsSecondPaymentCheck(true);
		}
		if (payment_amount && payment_amount.value !== 'other') {
			document.getElementById('pay_other_amount').value = '';
			setAmtReadOnly(true);
		} else {
			setAmtReadOnly(false);
		}
		getUpdateNachaContent(event);
	};

	const getDayOfDate = (date) => {
		// Convert "m/d/y" to Date object
		const [month, day, year] = date.split('/');

		const jsDate = new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`);

		if (!isNaN(jsDate)) {
			//st48236 - changes for schedule payment - to get the day of the week based on the timezone - start
			const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			const onevariable = currentTimeZone.includes("America/") ? true : false;
			let dayOfWeek = '';
			if(onevariable === true){
				dayOfWeek = jsDate.toLocaleString('en-US', { timeZone: 'UTC', weekday: 'long' });
			}else{
				dayOfWeek = jsDate.toLocaleDateString('en-US', { weekday: 'long' });
			}
			//st48236 - changes for schedule payment - to get the day of the week based on the timezone - end
			return dayOfWeek;
		} else {
			return '';
		}
	};

	const validation = () => {
		let isValid = true;
		const errors = {};

		let schedule_date = document.getElementById('datepicker-input').value;
		if (schedule_date !== "") {
			setPopupDate(schedule_date);
			let scheduleDay = getDayOfDate(schedule_date);
			setPopupDay(scheduleDay);
		}
		let pay_other_amount = 0;
		let payment_amount = document.querySelector('input[name="payment_amount"]:checked');
		if (payment_amount) {
			pay_other_amount = payment_amount.value;
		}
		let auth_esignature = document.querySelector('#auth_esignature_chkbox').checked;
		errors.third = false;
		errors.first = false;
		errors.second = false;
		if (pay_other_amount === 'other') {
			pay_other_amount = document.getElementById('pay_other_amount').value;
		}

		let payment_account = document.getElementById('payment_account').value;

		if (pay_other_amount <= 0) {
			errors.amount = billingContent?.notification_message_payment_greater;
			isValid = false;
			if (payment_amount.id === 'amount_option_1') {
				errors.first = true;
			} else if (payment_amount.id === 'amount_option_2') {
				errors.second = true;
			} else if (payment_amount.id === 'amount_option_3') {
				errors.third = true;
			}
		} else if (parseInt(pay_other_amount) > maxValidationAmt) {
			toast.error(billingContent?.notification_message_payment_greater_10k);
			isValid = false;
		} else {
			setPopupAmount(pay_other_amount);
			delete errors.amount;
			delete errors.first;
			delete errors.second;
			delete errors.third;
		}

		if (payment_account === "") {
			errors.account = billingContent?.notification_message_payment_account_draft;
			isValid = false;
		} else {
			delete errors.account;
		}


		if (!auth_esignature) {
			errors.esignature = billingContent?.billing_nacha_e_signature_account_valut_instruction;
			isValid = false;
		} else {
			delete errors.esignature;
		}
		setFormErrors(errors);
		setValidation(isValid);
		return isValid;
	};

	const checkPopupSign = (e) => {
		setPopupFormErrors(prevErrors => ({ ...prevErrors, popupesign: '' }));
	};

	const popupValidation = () => {
		let isValid = true;
		const errors = {};
		let popup_auth_esignature = document.querySelector('#nacha-checkbox').checked;
		if (!popup_auth_esignature) {
			errors.popupesign = billingContent?.billing_paybill_schedule_payment_terms_and_conditions_error;
			isValid = false;
		} else {
			delete errors.popupesign;
		}
		setPopupFormErrors(errors);
		return isValid;
	};

	const handleClosePopupClick = () => {
		setSchedulePymntModelModal(false);
		setIsSubmitting(false);
	};

	const handleSchedulePaymentPopup = (e) => {
		if (e) e.preventDefault();
		setIsSubmitting(true); // Disable the button immediately
		if (validation()) {
			setSchedulePymntModelModal(true);
		} else {
			setIsSubmitting(false);
		}
	};

	const handleCancelPayment = (e, data_source, data_confnum) => {

		setCancelConfNum(data_confnum);
		setCancelDataSource(data_source);
		setCancelPymntModelModal(true);
	};

	const handleCloseCancelPymntsPopupClick = () => {
		setIsCancelSubmitting(false);
		setCancelPymntModelModal(false);
	};

	const handleCancelPaymentClick = (e) => {
		if (e) e.preventDefault();
		setCancelPayLoading(true);
		setIsCancelSubmitting(true);
		const payload = new FormData();
		const baseUrl = process.env.REACT_APP_API_BASE_URL;
		const targetCancelPymentUrl = process.env.REACT_APP_API_SCHPYMNT_CALL_ENDPOINT;
		let conf_num = document.getElementById('cancel_conf_num').value;
		let cancel_source = document.getElementById('cancel_data_source').value;
		payload.append("region", Payload?.region);
		payload.append("carrier", Payload?.owning_carrier);
		payload.append("cim", Payload?.cim);
		payload.append("conf_num", conf_num);
		payload.append("case_num", Payload?.case_num);
		payload.append("cancel_source", cancel_source);
		payload.append("action", 'cancel_payment');
		payload.append("sitecd", Payload?.site_cd);
		postApiService(baseUrl, targetCancelPymentUrl, payload, headers).then((response) => {
			if (response?.data && response?.data?.status == 'SUCCESS') {
				setCancelPayLoading(false);
				setIsCancelSubmitting(false);
				const result = response.data.data;
				toast.success(billingContent?.schedule_payment_cancel_payment_successful);
				setCancelPymntModelModal(false);
				refreshScheduledPayments();
			} else {
				setCancelPayLoading(false);
				setIsCancelSubmitting(false);
				toast.error('Cancel Payment - ' + genericContent?.service_post_error, response?.data?.message);
			}
		})
			.catch(error => {
				setCancelPayLoading(false);
				setIsCancelSubmitting(false);
				toast.error('Cancel Payment - ' + genericContent?.service_post_error, error);
			});

	};

	const handleContinueClick = () => {
		setContinueSchedulePaymentModal(true);
	};

	const callConfirmationPage = () => {
		let conf_num = confirmationNum;
		const prd_lvl_carrier = Payload?.owning_carrier;
		let current_date = formatDate(new Date());
		let schedule_date = document.getElementById('datepicker-input').value;
		let pay_other_amount = 0;
		let payment_amount = document.querySelector('input[name="payment_amount"]:checked');
		if (payment_amount) {
			pay_other_amount = payment_amount.value;
		}
		let auth_esignature = document.querySelector('#auth_esignature_chkbox').checked;
		if (pay_other_amount === 'other') {
			pay_other_amount = document.getElementById('pay_other_amount').value;
		}
		let payment_account = document.getElementById('payment_account').value;
		let payment_account_data = document.getElementById('payment_account');
		let auth_pymt_method = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-pymt_method");
		let set_auth_pymt_method = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-pymt_method");
		if (auth_pymt_method === 'CC') {
			auth_pymt_method = 'CCD';
		}
		let auth_tras_num = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-tras_num");
		let auth_seccode = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-seccode");
		let auth_dtl_actype = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-dtl_actype");
		let auth_account_name = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-account_name");
		const formattedPayOtherAmount = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
		}).format(pay_other_amount);
		const post_val = { confirmationNumber: conf_num, authorizationId: authorizationId, paymentAmt: formattedPayOtherAmount, paymentType: set_auth_pymt_method, currentDate: current_date, scheduleDate: schedule_date, casenum: Payload?.case_num, cim: Payload?.cim, lastdigit: payment_account, auth_dtl_actype: auth_dtl_actype, auth_account_name: auth_account_name, prd_lvl_carrier: prd_lvl_carrier, "frequency": authFrequency, "sitecd": Payload?.site_cd };
		setPaymentLoading(false);
		navigate('/billing-confirmation', { state: post_val });
	};

	const handleActiveAcntClick = () => {
		const payload = new FormData();
		const targetActivateAccountUrl = process.env.REACT_APP_API_ACTIVATE_ACCOUNT_ENDPOINT;
		const prd_lvl_carrier = Payload?.owning_carrier;
		let auth_text = document.getElementById('auth_text').value;
		let current_date = formatDate(new Date());
		let schedule_date = document.getElementById('datepicker-input').value;
		let pay_other_amount = 0;
		let payment_amount = document.querySelector('input[name="payment_amount"]:checked');
		if (payment_amount) {
			pay_other_amount = payment_amount.value;
		}
		let auth_esignature = document.querySelector('#auth_esignature_chkbox').checked;
		if (pay_other_amount === 'other') {
			pay_other_amount = document.getElementById('pay_other_amount').value;
		}
		let payment_account = document.getElementById('payment_account').value;
		let payment_account_data = document.getElementById('payment_account');
		let auth_pymt_method = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-pymt_method");
		let set_auth_pymt_method = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-pymt_method");
		if (auth_pymt_method === 'CC') {
			auth_pymt_method = 'CCD';
		}
		let auth_tras_num = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-tras_num");
		let auth_seccode = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-seccode");
		let auth_actual_seccode = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-actual_seccode");
		let auth_dtl_actype = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-dtl_actype");
		let auth_transit = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-transit");
		let auth_tokenorg = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-tokenorg");
		let auth_tokenid = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-tokenid");
		let auth_expiry = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-expiry");
		let auth_account_name = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-account_name");
		const phonenumber = caseInfo?.phoneNumber;
		const formattedPayOtherAmount = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
		}).format(pay_other_amount);
		const payloads = new FormData();
		const updateDraftMethodUrl = process.env.REACT_APP_API_UPDATE_DRAFT_METHOD_ENDPOINT;
		payloads.append("sitecd", Payload?.site_cd);
		payloads.append("region", Payload?.region);
		payloads.append("case_num", Payload?.case_num);
		payloads.append("cim", Payload?.cim);
		payloads.append("set_auth_pymt_method", set_auth_pymt_method);
		payloads.append("auth_text", auth_text);
		payloads.append("auth_seccode", auth_actual_seccode);
		payloads.append("auth_dtl_actype", auth_dtl_actype);
		payloads.append("payment_amount", pay_other_amount);
		payloads.append("pay_other_amount", pay_other_amount);
		payloads.append("payment_account", payment_account);
		payloads.append("auth_tokenorg", auth_tokenorg);
		payloads.append("auth_tokenid", auth_tokenid);
		payloads.append("payment_account", payment_account);
		payloads.append("auth_transit", auth_transit);
		payloads.append("auth_dtl_actype", auth_dtl_actype);
		payloads.append("auth_expiry", auth_expiry);
		payloads.append("auth_tras_num", auth_tras_num);
		payloads.append("auth_account_name", auth_account_name);
		payloads.append("phonenumber", phonenumber);
		postApiService(baseUrl, updateDraftMethodUrl, payloads, headers
		).then((response) => {
			if (response?.data && response?.data?.status == 'SUCCESS') {
				setRecurringSchedulePaymentModal(false);
				callConfirmationPage();
			}
		}).catch(error => {
			const message = "Update draft " + genericContent?.service_post_error;
			toast.error(message);
		});
	};

	const handleRecurringModelCloseClick = () => {
		setRecurringSchedulePaymentModal(false);
		callConfirmationPage();
	};

	const handleCancelContinueClick = () => {
		setContinueSchedulePaymentModal(false);
		callConfirmationPage();
	};

	const handleSchedulePaymentClick = (e) => {
		if (e) e.preventDefault();
		if (popupValidation()) {
			setSchedulePymntModelModal(false);
			setIsSubmitting(true); // Disable the button immediately
			const casenum = Payload?.case_num;
			const cim = Payload?.cim;
			const prd_lvl_carrier = Payload?.owning_carrier;
			let dup_payment = document.getElementById('dup_payment').value;
			let future_payment = document.getElementById('future_payment').value;
			let nacha_verification = document.getElementById('nacha_verification').value;
			let action = document.getElementById('action').value;
			let auth_cur_premium = document.getElementById('auth_cur_premium').value;
			let auth_carrier_date_verbage = document.getElementById('auth_carrier_date_verbage').value;
			let auth_text = document.getElementById('auth_text').value;
			let schedule_date = document.getElementById('datepicker-input').value;
			let pay_other_amount = 0;
			let payment_amount = document.querySelector('input[name="payment_amount"]:checked');
			if (payment_amount) {
				pay_other_amount = payment_amount.value;
			}
			let auth_esignature = document.querySelector('#auth_esignature_chkbox').checked;
			if (pay_other_amount === 'other') {
				pay_other_amount = document.getElementById('pay_other_amount').value;
			}
			let payment_account = document.getElementById('payment_account').value;
			let payment_account_data = document.getElementById('payment_account');
			let auth_pymt_method = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-pymt_method");
			if (auth_pymt_method === 'EFT') {
				let contentTitle = billingContent?.billing_paybill_schedule_payment_popup_title_eft;
				setContinuePopupTitle(contentTitle ? contentTitle : 'EFT (Electronic Funds Transfer) Enrollment Notice');
			} else {
				let contentTitle = billingContent?.billing_paybill_schedule_payment_popup_title_cc;
				setContinuePopupTitle(contentTitle ? contentTitle : 'Activate Recurring Credit Card Payment (CCD)');
			}
			let auth_tras_num = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-tras_num");
			let auth_seccode = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-seccode");
			let auth_account_use = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-account_use");
			let auth_dtl_actype = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-dtl_actype");
			let auth_account_name = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-account_name");
			let frequency = ".otp";
			if (document.querySelector('input[type="checkbox"][id="enable_recurring_draft"]')) {
				let auth_payment_option = document.querySelector('#enable_recurring_draft').checked;
				if (auth_payment_option) {
					frequency = '.recurring-otp';
				}
			}
			setAuthFrequency(frequency);
			let current_date = formatDate(new Date());
			// Format as USD currency
			const formattedPayOtherAmount = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD',
			}).format(pay_other_amount);
			setPaymentLoading(true);
			setTimeout(() => {
				const payload = new FormData();
				const baseUrl = process.env.REACT_APP_API_BASE_URL;
				const targetLoginUrl = process.env.REACT_APP_API_SCHPYMNT_CALL_ENDPOINT;
				payload.append("sitecd", Payload?.site_cd);
				payload.append("region", Payload?.region);
				payload.append("case_num", casenum);
				payload.append("cim", cim);
				payload.append("request", 1);
				payload.append("nacha-verification", nacha_verification);
				payload.append("future_payment", future_payment);
				payload.append("dup_payment", dup_payment);
				payload.append("payment_amount", pay_other_amount);
				payload.append("pay_other_amount", pay_other_amount);
				payload.append("payment_account", payment_account);
				payload.append("dup_payment", dup_payment);
				payload.append("auth-frequency", frequency);
				if (frequency === '.recurring-otp') {
					payload.append("enable_recurring_draft", true);
				}
				payload.append("auth-agree-to-terms-conditions", false);
				payload.append("auth-account-type", auth_pymt_method);
				payload.append("seq_num", auth_tras_num);
				payload.append("auth-account-no", payment_account);
				payload.append("auth-account-name", auth_account_name);
				payload.append("auth-payment-amount", formattedPayOtherAmount);
				payload.append("auth-payment-date", schedule_date);
				payload.append("auth-today-date", current_date);
				payload.append("payment_date", schedule_date);
				payload.append("auth-carrier-name", carrier_name);
				payload.append("auth-carrier-date", auth_carrier_date_verbage);
				payload.append("auth-current-premium", auth_cur_premium);
				payload.append("auth_text", auth_text);
				payload.append("action", action);
				payload.append("auth-account-use", auth_account_use);
				payload.append("auth-sec-code-actual", auth_seccode);
				payload.append("auth-sec-code", auth_seccode);
				payload.append("auth-e-signature-checkbox", auth_esignature);
				setIsSubmitting(false);
				postApiService(baseUrl, targetLoginUrl, payload, headers
				).
					then((response) => {
						if (response?.data?.statusCode !== 200) {
							setPaymentLoading(false);
							setIsSubmitting(false);
							toast.error('Schedulepayment ' + genericContent?.service_post_error, response?.data?.message);
						} else {
							const result = response.data.data;
							const message = billingContent?.billing_paybill_schedule_payment_successful;
							toast.success(message);
							setConfirmationNum(result['confirmationNumber']);
							setAuthorizationId(result['authorizationId']);
							if (frequency === '.recurring-otp') {
								const message = billingContent?.billing_paybill_schedule_payment_successful;
								setRecurringSchedulePaymentModal(true);
							} else {
								const post_val = { confirmationNumber: result['confirmationNumber'], authorizationId: result['authorizationId'], paymentAmt: formattedPayOtherAmount, paymentType: auth_pymt_method, currentDate: current_date, scheduleDate: schedule_date, casenum: casenum, cim: cim, lastdigit: payment_account, auth_dtl_actype: auth_dtl_actype, auth_account_name: auth_account_name, prd_lvl_carrier: prd_lvl_carrier, "frequency": frequency, "sitecd": Payload?.site_cd };
								setPaymentLoading(false);
								navigate('/billing-confirmation', { state: post_val });
							}
						}
					}).catch(error => {
						setPaymentLoading(false);
						setIsSubmitting(false);
						toast.error('Schedulepayment: ' + genericContent?.service_post_error, error);
					});
			}, 2000); //Set delay 2 seconds for api call
		}
	};


	const getUpdateNachaContent = (e) => {
		setNachLoading(true);
		let lang = Cookies.get('lang') || 'eng';
		let schedule_date = document.getElementById('datepicker-input').value;
		let pay_other_amount = 0;
		let payment_amount = document.querySelector('input[name="payment_amount"]:checked');
		if (payment_amount) {
			pay_other_amount = payment_amount.value;
		}
		let auth_esignature = document.querySelector('#auth_esignature_chkbox').checked;
		let payment_option = '.otp';
		if (document.querySelector('input[type="checkbox"][id="enable_recurring_draft"]')) {
			let auth_payment_option = document.querySelector('#enable_recurring_draft').checked;
			if (auth_payment_option) {
				payment_option = '.recurring-otp';
			}
		}
		if (pay_other_amount === 'other') {
			pay_other_amount = document.getElementById('pay_other_amount').value;
		}
		let payment_account = document.getElementById('payment_account').value;
		let payment_account_data = document.getElementById('payment_account');
		let auth_carrier_date_verbage = document.getElementById('auth_carrier_date_verbage').value;
		if (auth_carrier_date_verbage === undefined || auth_carrier_date_verbage === null || auth_carrier_date_verbage === '') {
			auth_carrier_date_verbage = carrierDateVerbage;
		}
		let auth_pymt_method = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-pymt_method");
		let auth_tras_num = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-tras_num");
		let auth_seccode = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-seccode");
		let auth_account_use = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-account_use");
		let auth_dtl_actype = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-dtl_actype");
		let auth_account_name = payment_account_data.options[payment_account_data.selectedIndex].getAttribute("data-account_name");
		if (payment_account === '') {
			payment_account = '0000';
			auth_pymt_method = 'EFT';
			auth_account_use = '';
		}
		const formattedPayOtherAmount = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
		}).format(pay_other_amount);

		const targetGetNachaContentUrl = process.env.REACT_APP_API_SCHPYMNT_NACHA_CONTENT_ENDPOINT;
		getApiService(baseUrl, targetGetNachaContentUrl, { "region": Payload?.region, "case_num": Payload?.case_num, "cim": Payload?.cim, "request": 1, "payment_option": payment_option, "account_type_cd": auth_pymt_method, "payment_account": payment_account, "payment_amount": formattedPayOtherAmount, "carrier_name": carrier_name, "carrier_date": schedule_date, "account_use": auth_account_use, "carrier_draft_date": auth_carrier_date_verbage, "lang": lang, "sitecd": Payload?.site_cd }, headers)
			.then((response) => {
				if (response?.data && response?.data?.status == 'SUCCESS') {
					const result = response.data.data;
					setnachaContents(result);
					setNachLoading(false);
				} else {
					setnachaContents('');
					setNachLoading(false);
					toast.error('Nacha content data ' + genericContent?.service_calling_error, response?.data?.message);
				}
			})
			.catch(error => {
				setNachLoading(false);
				toast.error('Nacha content data: ' + genericContent?.service_calling_error, error);
			});
	};

	const refreshAccounts = () => {
		const targetGetActiveAccountsUrl = process.env.REACT_APP_API_GET_ACTIVE_ACCOUNTS_ENDPOINT;
		getApiService(baseUrl, targetGetActiveAccountsUrl, { cim: Payload?.cim, request: '1' }, headers)
			.then((response) => {
				if (response?.data && response?.data?.status == 'SUCCESS') {
					const result = response.data.data;
					setActiveAccounts(result);
				} else {
					setActiveAccounts([]);
					toast.error('Active accounts data ' + genericContent?.service_calling_error, response?.data?.message);
				}
			})
			.catch(error => {
				toast.error('Active accounts data: ' + genericContent?.service_calling_error, error);
			});

		if (activeAccounts.length > 0) {
			{
				activeAccounts?.map((item, key) => {
					if ((primaryAccount?.MainAccountType === item?.mainAccountType && primaryAccount?.vault_id === item?.vaultId && primaryAccount?.primaryActive === 'Y')) {
						document.getElementById('payment_account').value = item?.accountNumLastFour;
					}
				})
			}
		} else {
			document.getElementById('payment_account').value = '';
		}
	};

	const refreshScheduledPayments = () => {
		setRecentScheduledPaymentsLoading(true);
		const targetScheduledPaymentsUrl = process.env.REACT_APP_API_PAYMENT_HISTORY_ENDPOINT;
		const phpayload = new FormData();
		phpayload.append("cim", Payload?.cim);
		postData(baseUrl, targetScheduledPaymentsUrl, phpayload, headers).then((result) => {
			if (result.status && result.data && result.status === 200) {
				let response = result.data;
				if (!response.error) {
					setRecentScheduledPaymentsLoading(false);
					if (response && response?.status === 'SUCCESS') {
						const result = response;
						setScheduledPayments(result?.schedulePayments);
					} else {
						setScheduledPayments([]);
						toast.error('Scheduled payments data ' + genericContent?.service_calling_error, response?.data?.message);
					}
				}
			}
		})
			.catch(error => {
				console.log('Scheduled payments data ' + genericContent?.service_calling_error, error);
			});
	};

	useEffect(() => {
		if (Cookies.get('region')) {
			setRegion(Cookies.get('region'));
		}

		if (pageContent?.generic) {
			setGenericContent(pageContent.generic);
		}else if (contentFromExternal?.generic) { // This is to handle the case where content is fetched from an external source
			setGenericContent(contentFromExternal.generic);
		}

		if (pageContent?.billing) {
			setBillingContent(pageContent.billing);
		} else if (contentFromExternal?.billing) { // This is to handle the case where content is fetched from an external source
			setBillingContent(contentFromExternal.billing);
		} else {
			setBillingContent(pageContent.overview);
		}

		//getUpdateNachaContent(); /* st48236 - changes for schedule payment */
	}, [pageContent]);

	useEffect(() => {
		let notificationMsg;
		if (genericContent.length == 0) {
			notificationMsg = pageContent?.generic;
		} else {
			notificationMsg = genericContent;
		}
		const targetCaseUrl = process.env.REACT_APP_API_CASE_INFO_ENDPOINT;
		getApiService(baseUrl, targetCaseUrl, { cim: Payload?.cim, apiSource: 'settings' }, headers)
			.then((response) => {
				if (response?.data && response?.data?.status == 'SUCCESS') {
					const result = response.data.data;
					setCaseInfo(response.data.data);
				} else {
					toast.error('Case Information ' + notificationMsg?.service_calling_error, response?.data?.message);
				}
			})
			.catch(error => {
				toast.error('Case Information : ' + notificationMsg?.service_calling_error);
			});

		const targetScheduledPaymentsUrl = process.env.REACT_APP_API_PAYMENT_HISTORY_ENDPOINT;
		const phpayload = new FormData();
		phpayload.append("cim", Payload?.cim);
		postData(baseUrl, targetScheduledPaymentsUrl, phpayload, headers).then((result) => {
			if (result.status && result.data && result.status === 200) {
				let response = result.data;
				if (!response.error) {
					setRecentScheduledPaymentsLoading(false);
					if (response && response?.status === 'SUCCESS') {
						const result = response;
						setScheduledPayments(result?.schedulePayments);
						if (result?.schedulePayments.length > 0) {
							const message = "Are you sure you wish to schedule another Payment? There are scheduled payments pending, please review your recent payments before proceeding.";
							toast.warning(
								<>{parse(notificationMsg?.billing_paybill_schedule_payment_notice_push ? notificationMsg?.billing_paybill_schedule_payment_notice_push : message)}</>
							);
						}
					} else {
						setScheduledPayments([]);
						toast.error('Scheduled payments data ' + notificationMsg?.service_calling_error, response?.data?.message);
					}
				}
			}
		})
			.catch(error => {
				console.log('Scheduled payments data ' + genericContent?.service_calling_error, error);
			});

		const targetGetActiveAccountsUrl = process.env.REACT_APP_API_GET_ACTIVE_ACCOUNTS_ENDPOINT;
		getApiService(baseUrl, targetGetActiveAccountsUrl, { cim: Payload?.cim, request: '1' }, headers)
			.then((response) => {
				if (response?.data && response?.data?.status == 'SUCCESS') {
					const result = response.data.data;
					setActiveAccounts(result);
				} else {
					setActiveAccounts([]);
					toast.error('Active accounts ' + notificationMsg?.service_calling_error, response?.data?.message);
				}
			})
			.catch(error => {
				toast.error('Active accounts data: ' + notificationMsg?.service_calling_error, error);
			});

		const targetGetCaseTypesUrl = process.env.REACT_APP_API_CASE_TYPE_DTL_ENDPOINT;
		getApiService(baseUrl, targetGetCaseTypesUrl, { cim: Payload?.cim, case_num: Payload?.case_num, request: '1', "sitecd": Payload?.site_cd }, headers)
			.then((response) => {
				if (response?.data && response?.data?.status == 'SUCCESS') {
					const result = response.data.data;
					setcaseTypeArr(result?.type);
					setcaseTypeUSAArr(result?.type_usa);
					setMaxValidationAmt(parseInt(result.max_validation_amt));
					setHideAutoPay(result?.setHideAutoPay);
					setEnableDraftOption(result?.enableDraftOption);
				} else {
					setcaseTypeArr('');
					setcaseTypeUSAArr('');
					setMaxValidationAmt('');
					setHideAutoPay(true);
					setEnableDraftOption(false);
					toast.error('Get case type ' + notificationMsg?.service_calling_error, response?.data?.message);
				}
			})
			.catch(error => {
				toast.error('Get case type : ' + notificationMsg?.service_calling_error, error);
			});

		const targetGetDuePaymentUrl = process.env.REACT_APP_API_DUE_PAYMENT_DTL_ENDPOINT;
		getApiService(baseUrl, targetGetDuePaymentUrl, { cim: Payload?.cim, case_num: Payload?.case_num, request: '1', "sitecd": Payload?.site_cd }, headers)
			.then((response) => {
				if (response?.data && response?.data?.status == 'SUCCESS') {
					const result = response.data.data;
					setDuePayments(result);
				} else {
					setDuePayments([]);
					toast.error('Due payment data ' + notificationMsg?.service_calling_error, response?.data?.message);
				}
			})
			.catch(error => {
				toast.error('Due payment data: ' + notificationMsg?.service_calling_error, error);
			});

		const targetGetCarrierDraftDateUrl = process.env.REACT_APP_API_CARRIER_DRAFT_DATE_ENDPOINT;
		getApiService(baseUrl, targetGetCarrierDraftDateUrl, { cim: Payload?.cim, "sitecd": Payload?.site_cd }, headers)
			.then((response) => {
				if (response?.data && response?.data?.status == 'SUCCESS') {
					const result = response.data.data;
					setCarrierDraftDate(result);
					setCarrierDateVerbage(result?.carrier_draft_month_verbage);
					setCarrierName(result?.carrier_name);
					getUpdateNachaContent(); /* st48236 - changes for schedule payment */
				} else {
					setCarrierDraftDate([]);
					toast.error('Carrier draft date ' + notificationMsg?.service_calling_error, response?.data?.message);
				}
			})
			.catch(error => {
				toast.error('Carrier draft date: ' + notificationMsg?.service_calling_error, error);
			});

		const targetGetPrimaryAcountUrl = process.env.REACT_APP_API_GET_PRIMARY_ACCOUNT_ENDPOINT;
		getApiService(baseUrl, targetGetPrimaryAcountUrl, { cim: Payload?.cim }, headers)
			.then((response) => {
				if (response?.data && response?.data?.status == 'SUCCESS') {
					const result = response.data.data;
					setPrimaryAccount(result);
				} else {
					setPrimaryAccount([]);
					toast.error('Primary account ' + notificationMsg?.service_calling_error, response?.data?.message);
				}
			})
			.catch(error => {
				toast.error('Primary account :' + notificationMsg?.service_calling_error, error);
			});
	}, []);
	/* st48236 - changes for schedule payment */

	// Focus management for automatic screen reader
	const hasAutoFocusedRef = useRef(false);
	useEffect(() => {
		const handleUserInteraction = () => {
			userInteractedRef.current = true;
		};
		document.addEventListener('click', handleUserInteraction);
		document.addEventListener('keydown', handleUserInteraction);
		return () => {
			document.removeEventListener('click', handleUserInteraction);
			document.removeEventListener('keydown', handleUserInteraction);		};
	}, []);

	useEffect(() => {
		let timeoutId;

		const apiCallsCompleted =
			!recentScheduledPaymentsLoading && !isNachaLoading;

		if (
			apiCallsCompleted &&
			schedulePaymentContentRef.current &&
			!hasAutoFocusedRef.current
		) {
			timeoutId = setTimeout(() => {
				hasAutoFocusedRef.current = true;
				const activeEl = document.activeElement;
				const isEditingField =
					activeEl &&
					(activeEl.tagName === 'INPUT' ||
						activeEl.tagName === 'TEXTAREA' ||
						activeEl.tagName === 'SELECT' ||
						activeEl.isContentEditable);

				if (!userInteractedRef.current && !isEditingField) {
					requestAnimationFrame(() => {
						schedulePaymentContentRef.current.focus({ preventScroll: true });
					});
				}
			}, Number(process.env.REACT_APP_READABILITY_TIMEOUT) || 100);
		}

		return () => {
			if (timeoutId) clearTimeout(timeoutId);
		};
	}, [recentScheduledPaymentsLoading, isNachaLoading]);


	return (

		<>
			{/* nk90467 modal changes */}
			<Modal size="x1" show={continueSchedulePaymentModal} onHide={() => handleCancelContinueClick()}>
				<Modal.Header className={`multipleaccounts pb-4 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
					<Modal.Title>
						{Payload?.owning_carrier === 'Q5' ? (
							<h3 tabIndex={0} className="q5-schedule-payment-title">{continuePopupTitle}</h3>
						) : (
							<h5 tabIndex={0}>{continuePopupTitle}</h5>
						)}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div class={Payload?.owning_carrier === 'Q5' ? "qtip-content text-colour":"qtip-content"} id="qtip-0-content" aria-atomic="true">

						{/* Q5 carrier: Responsive button order for Continue/Cancel */}
						{Payload?.owning_carrier === 'Q5' ? (
							<>
								{/* Mobile/Tablet: Continue on top, Cancel at bottom */}
								<div className="d-block d-lg-none w-100">
									<button className="me-3 btn btn-secondary btn-lg col-5 switchtoebillbtn" onClick={() => handleActiveAcntClick()}>{billingContent?.billing_paybill_schedule_payment_button_continue ? billingContent?.billing_paybill_schedule_payment_button_continue : "Continue"}</button>
									<button className="btn btn-outline-secondary btn-lg col-5 cancelrequestbtn" onClick={() => handleCancelContinueClick()}>{billingContent?.billing_schedule_payment_cancel_btn ? billingContent?.billing_schedule_payment_cancel_btn : "Cancel"}</button>
								</div>
								{/* Large screens: Cancel first, Continue second */}
								<div className="d-none d-lg-flex w-100 justify-content-start">
									<button className="me-3 btn btn-outline-secondary btn-lg col-5 cancelrequestbtn" onClick={() => handleCancelContinueClick()}>{billingContent?.billing_schedule_payment_cancel_btn ? billingContent?.billing_schedule_payment_cancel_btn : "Cancel"}</button>
									<button className="btn btn-secondary btn-lg col-5 switchtoebillbtn" onClick={() => handleActiveAcntClick()}>{billingContent?.billing_paybill_schedule_payment_button_continue ? billingContent?.billing_paybill_schedule_payment_button_continue : "Continue"}</button>
								</div>
							</>
						) : (
							<>
								<button className="me-3 btn btn-outline-secondary btn-lg col-5 cancelrequestbtn" onClick={() => handleCancelContinueClick()}>{billingContent?.billing_schedule_payment_cancel_btn ? billingContent?.billing_schedule_payment_cancel_btn : "Cancel"}</button>
								<button className="btn btn-secondary btn-lg col-5 switchtoebillbtn" onClick={() => handleActiveAcntClick()}>{billingContent?.billing_paybill_schedule_payment_button_continue ? billingContent?.billing_paybill_schedule_payment_button_continue : "Continue"}</button>
							</>
						)}
						<p className="mt-2" style={{ fontSize: "13px" }} >{billingContent?.billing_paybill_schedule_payment_popup_verify_email ? billingContent?.billing_paybill_schedule_payment_popup_verify_email : "Please verify your email:"}</p>
						<p className="very_small" style={{ fontSize: "13px" }} >{billingContent?.billing_paybill_schedule_payment_popup_change_email ? parse(billingContent?.billing_paybill_schedule_payment_popup_change_email) : parse('If your email is wrong you can change it by visiting your profile <strong><a className="fw-semibold emailebill p-1" href="/settings">page</a></strong>')}</p>
						<div className="">
							<div class="table_box" style={{ fontSize: "13px" }}>
								<table cellspacing="0" cellpadding="0" border="0" id="tbl_correspondence_address">
									<tbody>
										<tr class="even">
											<th className="emailebill">{billingContent?.billing_paybill_schedule_payment_popup_email ? billingContent?.billing_paybill_schedule_payment_popup_email : 'Email:'}</th>
											<td class="no_right_border">
												{caseInfo?.email ? caseInfo?.email : billingContent?.billing_paybill_schedule_payment_popup_no_email ? billingContent?.billing_paybill_schedule_payment_popup_no_email : 'No Email Address Found'}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div>
								<p>{duePayments[0]?.next_billing_date ? duePayments[0]?.next_billing_date : ''}</p>
								<p>{billingContent?.billing_paybill_schedule_payment_popup_enroll ? billingContent?.billing_paybill_schedule_payment_popup_enroll : '* Member enrolled in e-Bill do not receive paper statements. By continuing you agree to receive your bill electronically.'}
								</p>
								<p>{billingContent?.billing_paybill_schedule_payment_popup_recurringtext ? billingContent?.billing_paybill_schedule_payment_popup_recurringtext : '* Members who pay by recurring electronic transfer do not receive paper statements. By continuing, you agree to have your balance deducted from your account.'}</p>
							</div>
						</div>
					</div>
				</Modal.Body>
			</Modal>

			{/* nk90467 modal changes */}
			<Modal size="x1" show={recurringSchedulePaymentModal} onHide={handleRecurringModelCloseClick}>
				<Modal.Header className={`multipleaccounts pb-4 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
					<Modal.Title>
						{/* <h4 style={{ color: '#110081' }}>{billingContent?.billing_paybill_schedule_payment_title_dialog_payment_successful}</h4> */}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div class={Payload?.owning_carrier === 'Q5' ? "qtip-content text-colour":"qtip-content"} id="qtip-0-content" aria-atomic="true">
						<p style={{ fontSize: "13px" }} ><strong>{billingContent?.billing_paybill_schedule_payment_title_dialog_payment_successful ? billingContent?.billing_paybill_schedule_payment_title_dialog_payment_successful : "Payment Schedule Successful"}</strong></p>
						<p style={{ fontSize: "13px" }} >{billingContent?.billing_paybill_schedule_payment_your_payment_successful ? billingContent?.billing_paybill_schedule_payment_your_payment_successful : "Your payment was successfully added."}</p>
						<button className="btn btn-secondary btn-lg mt-2 col-5 switchtoebillbtn" onClick={() => handleContinueClick()}>{billingContent?.billing_paybill_schedule_payment_button_continue ? billingContent?.billing_paybill_schedule_payment_button_continue : "Continue"}</button>
					</div>
				</Modal.Body>
			</Modal>

			{/* nk90467 modal changes */}
			{schedulePayPopupModal && (
				<Modal size="x1" show={schedulePayPopupModal} onHide={handleClosePopupClick} >
					<Modal.Header className={`multipleaccounts pb-4 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
						<Modal.Title>
							{/* <h4 style={{ color: '#110081' }}>Confirm One-Time Payment</h4> */}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div class={Payload?.owning_carrier === 'Q5' ? "qtip-content text-colour" : "qtip-content"} id="qtip-0-content" aria-atomic="true">
							<p><strong className="schedulepayment-confirm-title">{billingContent?.billing_paybill_schedule_payment_confirm_one_time ? billingContent?.billing_paybill_schedule_payment_confirm_one_time : "Confirm One-Time Payment"}</strong></p>
							<p className="lh-base" style={{ fontSize: "13px" }}>{billingContent?.billing_paybill_schedule_payment_schedule_one_time_payment ? billingContent?.billing_paybill_schedule_payment_schedule_one_time_payment : "Are you sure you wish to schedule a One-Time payment for the amount of "}<strong> ${popupAmount}</strong></p>
							<p className="lh-base" style={{ fontSize: "13px" }}>{billingContent?.billing_paybill_other_amount_date ? billingContent?.billing_paybill_other_amount_date : "The payment copy will be sent to Your Payment will be scheduled on your selected Payment Date of "}<strong> {popupDate} ({popupDay})</strong>.</p>
							<div className="mt-3 modal-form-checkbox d-flex gap-2">
								<input
									className="form-check-input"
									id="nacha-checkbox"
									name="nacha-checkbox"
									type="checkbox"
									onChange={(e) => checkPopupSign(e)}
									onKeyDown={(e) => {
										if (e.key === 'Enter') {
											e.preventDefault();
											e.target.click();
										}
									}}
								/>
								<label htmlFor="nacha-checkbox" className="fw-bold">
									{billingContent?.billing_v2_nacha_content_pop_checkbox_label
										? billingContent.billing_v2_nacha_content_pop_checkbox_label
										: "By checking this box you provide your e-signature and agree to the payment terms"}
								</label>
							</div>

							{popupFormErrors.popupesign && <p className="invalid-feedback">{popupFormErrors.popupesign}</p>}

							{/* Q5 carrier: Responsive button order for Ok/Cancel in popup */}
							{Payload?.owning_carrier === 'Q5' ? (
								<>
									{/* Mobile/Tablet: Ok on top, Cancel at bottom */}
									<div className="d-block d-lg-none w-100">
										<button className="me-3 btn btn-secondary btn-lg mt-4 col-5 switchtoebillbtn" onClick={() => handleSchedulePaymentClick()}>{billingContent?.billing_schedule_payment_ok_btn ? billingContent?.billing_schedule_payment_ok_btn : "Ok"}</button>
										<button className="btn btn-outline-secondary btn-lg mt-4 col-5" onClick={handleClosePopupClick}>{billingContent?.billing_schedule_payment_cancel_btn_text ? billingContent?.billing_schedule_payment_cancel_btn_text : "Cancel"}</button>
									</div>
									{/* Large screens: Cancel first, Ok second */}
									<div className="d-none d-lg-flex w-100 justify-content-start">
										<button className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5" onClick={handleClosePopupClick}>{billingContent?.billing_schedule_payment_cancel_btn_text ? billingContent?.billing_schedule_payment_cancel_btn_text : "Cancel"}</button>
										<button className="btn btn-secondary btn-lg mt-4 col-5 switchtoebillbtn" onClick={() => handleSchedulePaymentClick()}>{billingContent?.billing_schedule_payment_ok_btn ? billingContent?.billing_schedule_payment_ok_btn : "Ok"}</button>
									</div>
								</>
							) : (
								<>
									<button className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5" onClick={handleClosePopupClick}>{billingContent?.billing_schedule_payment_cancel_btn_text ? billingContent?.billing_schedule_payment_cancel_btn_text : "Cancel"}</button>
									<button className="btn btn-secondary btn-lg mt-4 col-5 switchtoebillbtn" onClick={() => handleSchedulePaymentClick()}>{billingContent?.billing_schedule_payment_ok_btn ? billingContent?.billing_schedule_payment_ok_btn : "Ok"}</button>
								</>
							)}
						</div>
					</Modal.Body>
				</Modal>
			)}

			{/* nk90467 modal changes */}
			<Modal size="x1" show={cancelPayPopupModal} onHide={handleCloseCancelPymntsPopupClick}>
				<Modal.Header className={`multipleaccounts pb-4 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
					<Modal.Title>
						{/* <h4 style={{ color: '#110081' }}>Cancel Payment</h4> */}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<input type="hidden" id="cancel_conf_num" name="cancel_conf_num" value={cancelConfNum} />
					<input type="hidden" id="cancel_data_source" name="cancel_data_source" value={cancelDataSource} />
					<div class={Payload?.owning_carrier === 'Q5' ? "qtip-content text-colour" : "qtip-content"} id="qtip-0-content" aria-atomic="true">
						<p tabIndex={0}>{billingContent?.billing_schedule_payment_base_cancel_payment_info_one ? billingContent?.billing_schedule_payment_base_cancel_payment_info_one : "By cancelling this payment your account will not be drafted."}</p>
						<p tabIndex={0}>{billingContent?.billing_schedule_payment_base_cancel_payment_info_two ? billingContent?.billing_schedule_payment_base_cancel_payment_info_two : "This operation can not be undone. Do you wish to continue?"}</p>

						{/* Q5 carrier: Responsive button order for Resume Payment/Cancel Payment */}
						{Payload?.owning_carrier === 'Q5' ? (
							<>
								{/* Mobile/Tablet: Resume Payment on top, Cancel Payment at bottom */}
								<div className="d-block d-lg-none w-100">
									<button className="me-3 btn btn-secondary btn-lg mt-4 col-5 cancelrequestbtn" onClick={() => handleCloseCancelPymntsPopupClick()}>{billingContent?.billing_schedule_payment_base_resume_payment ? billingContent?.billing_schedule_payment_base_resume_payment : "Resume Payment"}</button>
									<button className="btn btn-outline-secondary btn-lg mt-4 col-5 switchtoebillbtn" onClick={() => handleCancelPaymentClick()} disabled={isCancelSubmitting}>{billingContent?.billing_schedule_payment_base_cancel_payment ? billingContent?.billing_schedule_payment_base_cancel_payment : "Cancel Payment"}</button>
								</div>
								{/* Large screens: Resume Payment first, Cancel Payment second */}
								<div className="d-none d-lg-flex w-100 justify-content-start">
									<button className="me-3 btn btn-secondary btn-lg mt-4 col-5 cancelrequestbtn" onClick={() => handleCloseCancelPymntsPopupClick()}>{billingContent?.billing_schedule_payment_base_resume_payment ? billingContent?.billing_schedule_payment_base_resume_payment : "Resume Payment"}</button>
									<button className="btn btn-outline-secondary btn-lg mt-4 col-5 switchtoebillbtn" onClick={() => handleCancelPaymentClick()} disabled={isCancelSubmitting}>{billingContent?.billing_schedule_payment_base_cancel_payment ? billingContent?.billing_schedule_payment_base_cancel_payment : "Cancel Payment"}</button>
								</div>
							</>
						) : (
							<>
								<button className="me-3 btn btn-secondary btn-lg mt-4 col-5 cancelrequestbtn" onClick={() => handleCloseCancelPymntsPopupClick()}>{billingContent?.billing_schedule_payment_base_resume_payment ? billingContent?.billing_schedule_payment_base_resume_payment : "Resume Payment"}</button>
								<button className="btn btn-outline-secondary btn-lg mt-4 col-5 switchtoebillbtn" onClick={() => handleCancelPaymentClick()} disabled={isCancelSubmitting}>{billingContent?.billing_schedule_payment_base_cancel_payment ? billingContent?.billing_schedule_payment_base_cancel_payment : "Cancel Payment"}</button>
							</>
						)}
					</div>
					{isCancelPayLoading && (
						<div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
							<Spinner animation="border" role="status" ></Spinner>
							<div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
						</div>
					)}
				</Modal.Body>
			</Modal>

			<Modal.Header className={`pb-3 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
				<Modal.Title>
					{Payload?.owning_carrier === 'Q5' ? (
						<h3 tabIndex={0} className="q5-schedule-payment-title">{billingContent?.billing_paybill_schedule_payment_title}</h3>
					) : (
						<h5 tabIndex={0}>{billingContent?.billing_paybill_schedule_payment_title}</h5>
					)}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div 
					ref={schedulePaymentContentRef}
					tabIndex="-1"
					role="region"
					aria-label={billingContent?.billing_paybill_schedule_payment_title || "Schedule Payment"}
					className={Payload.owning_carrier === 'Q5'?"d-xl-flex d-md-flex col-xl-12 col-sm-12 col-12 Schedule-payment text-colour":"d-xl-flex d-md-flex col-xl-12 col-sm-12 col-12 Schedule-payment"}
					style={{ outline: 'none' }}
				>
					{/*schedule payment - st48236 - start*/}
					<input type="hidden" id="csr_token" name="csrf_token_c23dc52655a4f3be3918ff7f6178d91228d1f1f27dab516390bdb85f1530205facde4527a881e23b1456446e224308971cba393a2b18a29868d807bbb10ea714" value="596a61a2862889bfdd7d284171c62911d662cc61f80bc8b2ff993c9039e1404a4d3abf1e00f6cf61df4f782e1032df13b20d21fbddfeb8c02c38b9269162d230" />
					<input type="hidden" id="future_payment" name="future_payment" value="" />
					<input type="hidden" id="dup_payment" name="dup_payment" value="false" />
					<input type="hidden" id="nacha_verification" name="nacha_verification" value="false" />
					<input type="hidden" id="action" name="action" value="pay_bill" />
					<input type="hidden" id="auth-frequency" name="auth-frequency" value={authFrequency} />
					<input type="hidden" id="auth_cur_premium" name="auth_cur_premium" value="$60" />
					<input type="hidden" id="auth_carrier_date_verbage" name="auth_carrier_date_verbage" value={carrierDraftDate?.carrier_draft_month_verbage} />
					<input type="hidden" id="auth_text" name="auth_text" value={encodeURIComponent(nachaContents)} />
					{/*schedule payment - st48236 - end*/}
					<div className="col-xl-6 col-md-6">
						<div className="mb-3" tabIndex={0}>
							<h6 className={Payload?.owning_carrier === 'Q5' ? "fw-normal text-colour" : "fw-normal"}>{billingContent?.billing_paybill_schedule_payment_payment_amount_label}</h6>
						</div>
						<div>
							{/* Option 1 */}
							<div
								className={
									!isValidation && formErrors.first && formErrors.amount
										? "form-control is-invalid"
										: "col-xl-12 mb-3 paymentradio d-flex align-items-center"
								}
							>
								<div
									tabIndex={0}
									onKeyDown={(e) =>
										handleRadioKeyDown(e, "amount_option_1")
									}
									className="radio-wrapper"
								>
									<input
										type="radio"
										id="amount_option_1"
										className=""
										name="payment_amount"
										value={duePayments[0]?.netdue ? duePayments[0]?.netdue : 0}
										onChange={(e) => checkRadioBtn(e)}
										checked={isFirstPaymentCheck}
										tabIndex={-1}
									/>
								</div>
								<label htmlFor="amount_option_1" className={Payload?.owning_carrier === 'Q5' ? "text-colour" : ""}>
									{billingContent?.billing_paybill_schedule_payment_pay_total_amount_label} (
									{duePayments[0]?.netDueDisplay
										? duePayments[0]?.netDueDisplay
										: "$0.00"}
									)
								</label>
							</div>

							{/* Option 2 */}
							<div
								className={
									!isValidation && formErrors.second && formErrors.amount
										? "form-control is-invalid"
										: "col-xl-12 mb-3 paymentradio d-flex align-items-center"
								}
							>
								<div
									tabIndex={0}
									onKeyDown={(e) =>
										handleRadioKeyDown(e, "amount_option_2")
									}
									className="radio-wrapper"
								>
									<input
										type="radio"
										id="amount_option_2"
										className=""
										name="payment_amount"
										value={
											duePayments[0]?.past_due_amt
												? duePayments[0]?.past_due_amt
												: 0
										}
										onChange={(e) => checkRadioBtn(e)}
										checked={isSecondPaymentCheck}
										tabIndex={-1}
									/>
								</div>
								<label htmlFor="amount_option_2" className={Payload?.owning_carrier === 'Q5' ? "text-colour" : ""}>
									{billingContent?.billing_paybill_schedule_payment_pay_past_due_amount_label} (
									{duePayments[0]?.delinquent_amount_display
										? duePayments[0]?.delinquent_amount_display
										: "$0.00"}
									)
								</label>
							</div>

							{/* Option 3 */}
							<div className="col-xl-12 mb-3 paymentradio d-flex align-items-center">
								<div
									tabIndex={0}
									onKeyDown={(e) =>
										handleRadioKeyDown(e, "amount_option_3")
									}
									className="radio-wrapper"
								>
									<input
										type="radio"
										id="amount_option_3"
										className=""
										name="payment_amount"
										value="other"
										onChange={(e) => checkRadioBtn(e)}
										checked={isThirdPaymentCheck}
										tabIndex={-1}
									/>
								</div>
								<label htmlFor="amount_option_3" className={Payload?.owning_carrier === 'Q5' ? "me-05 text-colour":"me-05"}>
									{billingContent?.billing_paybill_schedule_payment_pay_other_amount_label}
								</label>
								<div className="d-flex align-items-center">
									<span className="me-1 dollar-symbol">$</span>
									<div
										tabIndex={0}
										onKeyDown={(e) => {
											if (e.key === "Enter") {
												document.getElementById("pay_other_amount")?.focus();
											}
										}}
									>
										<input
											type="text"
											className={`form-control sml-input otheramount schedulepaymentdate${!isValidation && formErrors.third && formErrors.amount ? ' is-invalid error-border' : ''}`}
											name="pay_other_amount"
											id="pay_other_amount"
											placeholder="0.00"
											readOnly={amtReadOnly}
											onBlur={(e) => getUpdateThirdAmt(e)}
											aria-label="Other payment amount"
										/>
									</div>
								</div>
							</div>

							{!isValidation && formErrors.amount && (
								<div
									className="invalid-feedback"
									style={{
										display: "block",
										marginTop: "1px",
										important: "true",
									}}
								>
									{formErrors.amount}
								</div>
							)}
						</div>


						<div className="col-xl-12 mb-3">
							<div className="forms col-xl-10">
								<label tabIndex={0} htmlFor="datepicker-input" className={Payload?.owning_carrier === 'Q5' ?"form-label payment-date text-colour":"form-label payment-date"}>
									{billingContent?.billing_paybill_schedule_payment_payment_date_label}
								</label>
								<CustomDatePicker onChange={handleDateSelect} dueDate={duePayments[0]?.bill_per_beg_dt ? duePayments[0]?.bill_per_beg_dt : ''} />

								<div className="mb-3">
									<label tabIndex={0} for="exampleInputEmail1" className={Payload?.owning_carrier === 'Q5' ?"form-label payment-date text-colour":"form-label payment-date"}>{billingContent?.billing_paybill_schedule_payment_payment_account_label}</label>
									<div>
										<select className={`form-select form-control2 schedulepaymentbox ${!isValidation && formErrors.account ? 'form-control is-invalid' : 'd-flex'}`}
											aria-label="Default select example" id="payment_account" name="payment_account" onChange={(e) => getAccountComobox(e)}  >
											<option selected value="">{billingContent?.billing_paybill_select_payment_account}</option>
											{/* st48236 - changes for schedule payment */}
											{activeAccounts?.map((item, key) => {
												{/* st48236 - INC0295110 - avoid display of CCD for BCBSAZ - ADD hideCreditCard variable  */}
												let hideCreditCard = Cookies.get("owningCarrier") === "Q5" && item?.cardType === "CCD" && Cookies.get("binder_payment_flag") === "false" ? true : false;
												return (!hideCreditCard && (
													<option value={item?.accountNumLastFour} selected={activeAccounts.length == 1 ? "selected" : (primaryAccount?.MainAccountType === item?.mainAccountType && primaryAccount?.vault_id === item?.vaultId && primaryAccount?.primaryActive === 'Y') ? "selected" : ""} data-seccode={item?.mainAccountType === 'CCD' ? 'CCD' : 'WEB'} data-actual_seccode={item?.secCode} data-tras_num={item?.vaultId} data-pymt_method={item?.mainAccountType === 'CCD' ? 'CC' : 'EFT'} data-account_use={item?.bankAccType === 'P' ? 'Personal' : 'Business'} data-account_name={item?.accountName} data-dtl_actype={item?.detailedAccountType} data-tokenid={item?.tokenId} data-expiry={item?.ExpiryDate} data-tokenorg={item?.tokenOrg} data-transit={item?.transitNum} >{item?.accountName} / {item?.detailedAccountType} / XXXX {item?.accountNumLastFour}</option>
												))
											})}
											{/* st48236 - INC0295110 - avoid display of CCD for BCBSAZ - ADD hideCreditCard variable - end */}
											{/* st48236 - changes for schedule payment */}
										</select>
									</div>
									{!isValidation && formErrors.account && (
										<div
											className="invalid-feedback"
											style={{ display: 'block', marginTop: '1px', important: 'true' }}
										>
											{formErrors.account}
										</div>
									)}
									<a
										tabIndex={0}
										role="button"
										className={Payload?.owning_carrier === 'Q5' 
											? "mt-3 anchor-text anchor-text-q5" 
											: "text-decoration-underline mt-3 anchor-text"}
										onClick={handleAddNew}
										onKeyDown={(e) => {
											if (e.key === "Enter" || e.key === " ") {
												e.preventDefault(); // prevent scrolling on spacebar
												handleAddNew(e);
											}
										}}
									>
										{billingContent?.billing_paybill_schedule_payment_create_new_account_text}
									</a>
									{addNew && (<Modal size='xl' show={addNew} onHide={() => { setAddNew() }} >
										<Forms handleCloseModal={handleCloseModal} caseInfo={caseInfo} sendDataToParent={handleDataFromModal} contentFromExternal={contentFromExternal} />
									</Modal>)}
								</div>
								{autoPayFlag && enableDraftOption && (<div>
									<div className="mt-3 form-checkbox d-flex">
										<input
											className="form-check-input"
											type="checkbox"
											id="enable_recurring_draft"
											name="enable_recurring_draft"
											checked={isChecked}
											onChange={(e) => handleRecurringChange(e)}
											onKeyDown={(e) => {
												if (e.key === "Enter" || e.key === " ") {
													e.preventDefault(); // prevent page scroll for Space
													handleRecurringChange(e);
												}
											}}
										/>

										<label htmlFor="enable_recurring_draft" className={Payload?.owning_carrier === 'Q5' ? "form-label grey-heading mt-1 ms-2 text-colour":"form-label grey-heading mt-1 ms-2"}>
											{billingContent?.billing_paybill_schedule_payment_enable_recurring_draft}
										</label>
									</div>
									<div className="mt-2">
										<label className={Payload?.owning_carrier === 'Q5' ?"d-block note-billing text-colour":"d-block note-billing"}>
											{billingContent?.billing_paybill_schedule_payment_account_automatically_billed}
										</label>
									</div> </div>
								)}
								<div>
									<div className="mt-3 form-checkbox d-flex">
										<input
											id="auth_esignature_chkbox"
											name="auth_esignature_chkbox"
											className={`${!isValidation && formErrors.esignature ? "is-invalid" : "form-checkbox"} form-check-input`}
											type="checkbox"
											checked={isTermsAccepted}
											onChange={(e) => handleTermsChange(e)}
											onKeyDown={(e) => {
												if (e.key === "Enter") {
													e.preventDefault();
													const checkbox = document.querySelector("#auth_esignature_chkbox");
													checkbox.checked = !checkbox.checked;
													handleTermsChange({ target: checkbox });
												}
											}}
										/>
										<label
											htmlFor="auth_esignature_chkbox"
											className={Payload?.owning_carrier === 'Q5' ?"form-label grey-heading ms-2 text-colour":"form-label grey-heading ms-2"}
										>
											{billingContent?.billing_nacha_e_signature_terms_and_conditions}
										</label>
									</div>

									{/* !isValidation && formErrors.esignature && <p class="invalid-feedback">{formErrors.esignature}</p> */}

									{/* Only show the message if terms checkbox is NOT checked */}
									{!isTermsAccepted && (
										<div id="output" className="px-3">
											<div className="outputs">
												* {billingContent?.billing_nacha_e_signature_account_valut_instruction}
											</div>
										</div>
									)}
								</div>
								{/* <div className="mt-4 mb-4">
                                        <input type="submit" className="btn btn-primary btn-lg button" value="Schedule Payment" />
                                    </div> */}
								<div>


									{showAlert && (
										<div className="myAlert-center alert alert-danger animated flipInX alert-dismissible alerts">
											<button
												type="button"
												className="schedulepaymentclosebtn"
												aria-label="Close"
												onClick={() => setShowAlert(false)}
											>
												&times;
											</button>
											<div className="message">
												<h5 className="d-inline-flex">
													<div className="error mb-2">
														<div id="icon-wrapper">
															<div id="icon"></div>
														</div>
													</div>
													<span className="ms-2 mt-3 fw-semibold">
														Please select the account number before proceeding
													</span>
												</h5>
											</div>
										</div>
									)}

									{/* Buttons */}
									<div class="mt-4 mb-4">

										{/* Q5 carrier: Responsive button order for Schedule Payment/Cancel */}
										{Payload?.owning_carrier === 'Q5' ? (
											<>
												{/* Mobile/Tablet: Schedule Payment on top, Cancel at bottom */}
												<div className="d-block d-lg-none w-100 d-flex gap-3">
													<button
														className="btn btn-secondary btn-lg button"
														onClick={(e) => handleSchedulePaymentPopup(e)}
														disabled={isSubmitting}
													>
														{billingContent?.billing_schedule_payment_btn_text}
													</button>
													<button
														className="btn btn-outline-secondary btn-lg col-5"
														onClick={handleCloseSchedulePaymentModal}
													>
														{billingContent?.billing_schedule_payment_cancel_btn_text}
													</button>
												</div>
												{/* Large screens: Schedule Payment first, Cancel second */}
												<div className="d-none d-lg-flex justify-content-start">
													<button
														className="me-3 btn btn-secondary btn-lg button"
														onClick={(e) => handleSchedulePaymentPopup(e)}
														disabled={isSubmitting}
													>
														{billingContent?.billing_schedule_payment_btn_text}
													</button>
													<button
														className="btn btn-outline-secondary btn-lg col-5"
														onClick={handleCloseSchedulePaymentModal}
													>
														{billingContent?.billing_schedule_payment_cancel_btn_text}
													</button>
												</div>
											</>
										) : (
											<>
												<button
													className="btn btn-secondary btn-lg button"
													onClick={(e) => handleSchedulePaymentPopup(e)}
													disabled={isSubmitting}
												>
													{billingContent?.billing_schedule_payment_btn_text}
												</button>
												<button
													className="ms-3 btn btn-outline-secondary btn-lg col-5"
													onClick={handleCloseSchedulePaymentModal}
												>
													{billingContent?.billing_schedule_payment_cancel_btn_text}
												</button>
											</>
										)}
										{isPaymentLoading && (
											<div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
												<Spinner animation="border" role="status"></Spinner>
												<div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="Border-bg d-xl-block d-md-block d-sm-none d-none"></div>
					<div className="col-xl-5 col-md-5">
						<h5 tabIndex={0} className="fw-semibold">{billingContent?.billing_paybill_schedule_payment_terms_and_condition_title}</h5>
						<div className={Payload?.owning_carrier === 'Q5' ? "d-grid-tbl mb-4 mt-4 text-colour" : Payload?.owning_carrier === 'XC' ? "d-grid-tbl1 mb-4 mt-4" : "d-grid-tbl mb-4 mt-4"}>
							{/* st48236 - changes for schedule payment */}
							{isNachaLoading && (
								<div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
									<Spinner animation="border" role="status" ></Spinner>
									<div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
								</div>
							)}
							{!isNachaLoading && parse(nachaContents)}
						</div>
						<div className="col-12">
							<h6 tabIndex={0} className={Payload?.owning_carrier === 'Q5' ?"fw-semibold":"fw-semibold"}>{billingContent?.billing_paybill_schedule_payment_recently_scheduled_payments}</h6>
							{recentScheduledPaymentsLoading && (
								<div>
									<Spinner animation="border" role="status" ></Spinner>
									<div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
								</div>
							)}
							{!recentScheduledPaymentsLoading && scheduledPayments.length > 0 ? (
								<div>
									{scheduledPayments.map((item, key) => (
										<div className="mt-4 d-xl-flex">
											<div className="col-xl-6 d-xl-flex" tabIndex={0}>
												<button className="rounded-circle bg-blue border-0" tabIndex={-1}>
													<img src={money} alt="money" />
												</button>
												{Payload?.owning_carrier === 'Q5' && <h6 tabIndex={0} className="fw-medium d-xl-none d-sm-none d-md-none d-block inline ms-3 ms-xl-0 ms-md-0">{item?.amount}</h6>}
												<div className="ms-3 mt-2 ">
													<h6 className={Payload?.owning_carrier === 'Q5' ?"fw-medium":"fw-medium"}>{billingContent?.billing_alreadypay_type_text?billingContent?.billing_alreadypay_type_text:Payload.owning_carrier === 'Q5' ? 'Payment Type:':'Type'} 
													{Payload.owning_carrier === 'Q5' ? replaceWord(item?.type, "EFT", "Bank Account") : item?.type}</h6>
													<h6 className={Payload?.owning_carrier === 'Q5' ?"d-block mt-2":"d-block mt-2"}>{billingContent?.billing_alreadypay_for_text?billingContent?.billing_alreadypay_for_text:Payload.owning_carrier === 'Q5' ? 'for:':'For'} {item?.event_date}</h6>
												</div>
											</div>
											<div className="col-xl-6 mt-2 text-xl-end">
												<button
													type="button" data-conf_num={item?.conf_num}
													data-source={item?.data_source} className={Payload?.owning_carrier === 'Q5' ? "btn btn-outline-secondary rounded sml-btn me-2" : "btn btn-outline-primary rounded sml-btn me-2"} onClick={(e) => handleCancelPayment(e, item?.data_source, item?.conf_num)}
													disabled={isCancelSubmitting}
												>
													{billingContent?.billing_schedule_payment_cancel_btn_text ? billingContent?.billing_schedule_payment_cancel_btn_text : "Cancel"}
												</button> 
												<h6 tabIndex={0} className={`fw-medium d-inline-block${Payload?.owning_carrier === 'Q5' ? ' d-xl-block d-sm-block d-md-block d-none inline-blocks' : ''}`}>{item?.amount}</h6>
											</div>
										</div>
									))}
								</div>
							) : (
								!recentScheduledPaymentsLoading && scheduledPayments.length === 0 && (
									<div className="mt-4">
										<p className={Payload?.owning_carrier === 'Q5' ? "text-colour":""}>{billingContent?.billing_recent_schedule_payments_nodata_text}</p>
									</div>
								)
							)}
						</div>
					</div>
				</div>
				<div className="note-billing" tabIndex={0} style={scheduledPayments.length > 0 ? {paddingTop: '20px'} : {paddingTop: '0px'}}>
					<label className="fw-semibold">
						{caseType !== 'OFF-EXCHG' ? parse(String(billingContent?.billing_paybill_note_text)) : caseTypeUSA === 'offhix-usaa' ? parse(String(billingContent?.billing_paybill_note_text_offhixusaa)) : parse(String(billingContent?.billing_paybill_note_text_off))}
					</label>
				</div>
			</Modal.Body>
		</>
	)
}
export default Schedulepayment;